import React from "react";
import Spinner from "../../components/presentationals/Spinner";
import CustomCardEd1 from "../../components/customCardEd1";

const PerformanceDetails = ({
  data,
  wirelineAch,
  fetchWirelinePlanCsvApi,
  csvLoading,
}) => {
  return (
    <div
      className="whitebox wow fadeInUp"
      data-wow-delay=".6s"
      data-wow-duration="0.7s"
    >
      <div className="subtitlebox">
        <div className="subtitleboxChild">{data.tileName}</div>
      </div>
      <div className="row">
        {wirelineAch.loading ? (
          <Spinner />
        ) : (
          <CustomCardEd1
            tileName1={wirelineAch.data?.content?.[0]?.kpi ?? "No Data"}
            tileName2={wirelineAch.data?.content?.[1]?.kpi ?? "No Data"}
            csvName="Billed"
            value1={wirelineAch.data?.content?.[0]?.count ?? "0"}
            value2={wirelineAch.data?.content?.[1]?.count ?? "0"}
            csvDownload={
              data?.isCsvActive === "Y" ? fetchWirelinePlanCsvApi : ""
            }
            gradient={3}
            loading={csvLoading.plan}
          />
        )}
      </div>
    </div>
  );
};

export default PerformanceDetails;
